import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

interface DrawerRequest {
  component: unknown;
  data?: unknown;
  position?: 'left' | 'right' | 'top' | 'bottom';
  modal?: boolean;
}
@Injectable({
  providedIn: 'root',
})
export class DrawerService {
  private openDrawerSource = new Subject<DrawerRequest>();
  private closeDrawerSource = new Subject<void>();
  private drawerClosedSource = new Subject<void>();

  openDrawer$ = this.openDrawerSource.asObservable();
  closeDrawer$ = this.closeDrawerSource.asObservable();
  drawerClosed$ = this.drawerClosedSource.asObservable();

  open(
    component: unknown,
    data?: unknown,
    position?: 'left' | 'right' | 'top' | 'bottom',
    modal?: boolean
  ) {
    this.openDrawerSource.next({ component, data, position, modal });
  }

  close() {
    this.closeDrawerSource.next();
  }

  notifyClosed() {
    this.drawerClosedSource.next();
  }
}
